function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7901 4.22C16.8301 1.27 12.0301 1.27 9.09015 4.22C7.02015 6.27 6.40015 9.22 7.20015 11.82L2.50015 16.52C2.17015 16.86 1.94015 17.53 2.01015 18.01L2.31015 20.19C2.42015 20.91 3.09015 21.59 3.81015 21.69L5.99015 21.99C6.47015 22.06 7.14015 21.84 7.48015 21.49L8.30015 20.67C8.50015 20.48 8.50015 20.16 8.30015 19.96L6.36015 18.02C6.07015 17.73 6.07015 17.25 6.36015 16.96C6.65015 16.67 7.13015 16.67 7.42015 16.96L9.37015 18.91C9.56015 19.1 9.88015 19.1 10.0701 18.91L12.1901 16.8C14.7801 17.61 17.7301 16.98 19.7901 14.93C22.7401 11.98 22.7401 7.17 19.7901 4.22ZM14.5001 12C13.1201 12 12.0001 10.88 12.0001 9.5C12.0001 8.12 13.1201 7 14.5001 7C15.8801 7 17.0001 8.12 17.0001 9.5C17.0001 10.88 15.8801 12 14.5001 12Z",
  fill: "white"
});

var SvgKey = function SvgKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/key.e815668a.svg";
export { ForwardRef as ReactComponent };